<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <b-tabs content-class="mt-0 border-0">
        <b-tab title="Approval Roles" active>
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-7">
            <a v-if="getRoleId != '33'" @click="openPage('/userManagement/approval-roles/add')" class="btn-primary"><i
                class="fas fa-plus-square mr-5"></i>Add</a>
            <template v-if="getRoleId === '4' || getRoleId === '1'">
              <!-- <a @click="showModal('salesRelationModal')" class="btn-secondary ml-10"><i class="fas fa-plus-square mr-5"></i>Sales Relation</a> -->
            </template>
            <b-modal modal-class="modal-custom-image" hide-footer :ref="'salesRelationModal'" centered
              title="Sales Relation">
              <div class="p-10">
                <hr class="short-line left mb-10 mt-20">
              </div>
            </b-modal>
          </div>
          <div class="col-sm-5 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control"
                    placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(branch)="data">
            <!--          <template slot="branch" slot-scope="data">-->
            <span>{{ (data.item.branch) ? data.item.branch.name : '-' }}</span>
          </template>
          <template v-slot:cell(thumbnail)="data">
            <!--          <template slot="thumbnail" slot-scope="data">-->
            <b-btn @click="showModal('cs' + data.item.id)" size="sm" variant="outline-danger"><i
                class="fas fa-eye mr-5"></i>View</b-btn>
            <b-modal modal-class="modal-custom-image" hide-footer :ref="'cs' + data.item.id" centered
              title="Personal Training">
              <img class="w-100 img-fix" :src="parseImg(data.item.thumbnail)">
            </b-modal>
          </template>
          <template v-slot:cell(status)="data">
            <!--          <template slot="status" slot-scope="data">-->
            <b-badge :variant="getBadge(data.item.status)">{{ data.item.status }}</b-badge>
          </template>
          <template v-slot:cell(actions)="data">
            <!--          <template slot="actions" slot-scope="data">-->
            <b-button v-if="getRoleId != '33'" size="sm" @click="editSales('/userManagement/approval-roles/edit?id=' + data.item.id)"
              class="btn-table warning mr-1">
              <i class="far fa-edit"></i> Edit
            </b-button>
            <b-button v-if="getRoleId != '33'" size="sm" v-on:click="deleteSales(data.item.id)"
              class="btn-table danger">
              <i class="fas fa-times"></i> Delete
            </b-button>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage" :total-pages="totalPage"
          @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
      </div>
        </b-tab>
        <b-tab title="Inventory Approval">
          <div class="p-15">
            <inventory-approval-assignees />
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import InventoryApprovalAssignees from './InventoryApproval.vue'

export default {
  name: 'sales',
  components: {
    'app-pagination': Pagination,
    'inventory-approval-assignees': InventoryApprovalAssignees
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        // {
        //   key: 'access_menu.name',
        //   label: 'Menu',
        //   sortable: true
        // },
        {
          key: 'branch',
          label: 'Branch',
          sortable: true
        },
        {
          key: 'department',
          label: 'Department',
          sortable: true
        },
        {
          key: 'user_can_edit.name',
          label: 'Edit Role',
          sortable: true
        },
        {
          key: 'user_can_delete.name',
          label: 'Delete Role',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false
        }
      ],
      items: [],
      getSalesId: Auth.Session.get().paradigm_id,
      getRoleId: Auth.Session.get().paradigm_role,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0
    }
  },
  computed: {
    name() {
      return this.$route.name
    }
  },
  methods: {
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked(searchEvent) {
      this.fetchData()
    },
    getBadge(status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount(items) {
      return items.length
    },
    openPage(event) {
      this.$router.push(event)
    },
    editSales(event) {
      this.$router.push(event)
    },
    showModal(id) {
      this.$refs[id].show()
    },
    deleteSales(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('crm/v1/approval_roles/'.concat(event)).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    parseImg(value) {
      return Auth.apiUrl + 'crm/v1/img/sales/' + value
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('crm/v1/approval_roles?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    // this.getSalesId = Auth.Session.get().paradigm_id
    // console.log(this.getSalesId)
    this.fetchData()
  }
}
</script>

<style></style>
